import * as React from 'react'
import './LatestOrders.scss'
import {ActionType, orderType, reducerStoreType, selectWalletType} from "../../reducers/types";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import OrderItem from "./OrderItem";
import Grid from "@material-ui/core/Grid";
import CustomDialog from "../../components/CustomUIComp/CustomDialog";
import OrderDetailModal from "../Orders/OrderDetailModal";
import OrderRefundModal from "../Orders/OrderRefundModal";
import {GridSize} from "@material-ui/core/Grid/Grid";
import noDataIcon from '../../images/null_icon.svg';
import {injectIntl, IntlShape} from "react-intl";
import ManualQueryModal from "./ManualQueryModal";

interface IProps {
    dispatch: Dispatch<ActionType<any>>,
    currency: string,
    latest10List: orderType[],
    superView: boolean,
    selectWallet: selectWalletType,
    intl: IntlShape,
    refundModal: boolean,
    orderDetailModal: boolean,
    manualQueryModal: boolean
}

interface IState {
    modalOpen: boolean,
    type: number,
    openOrderNo: string
    refundModalOpen: boolean,
    amt: number
}

class LatestOrders extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            modalOpen: false,
            type: 0,
            openOrderNo: '',
            refundModalOpen: false,
            amt: 0
        }
    }

    onOrderClick = (item: orderType) => {
        this.setState({
            type: item.type,
            amt: item.tradeAmt,
        })

        this.props.dispatch({
            type: 'GET_ORDERS', payload: {
                type: 'detail', data: {
                    orderNo: item.orderNo
                }
            }
        })
    }
    openRefundDialog = () => {
        this.props.dispatch({type: 'TOGGLE_REFUND_MODAL', payload: {open: true}})
        this.props.dispatch({type: 'TOGGLE_ORDER_DETAIL_MODAL', payload: {open: false}})
    }
    closeDialog = () => {
        this.props.dispatch({type: 'TOGGLE_ORDER_DETAIL_MODAL', payload: {open: false}})
        this.setState({
            type: 0,
            openOrderNo: ''
        })
    }
    closeRefundDialog = () => {
        this.props.dispatch({type: 'TOGGLE_REFUND_MODAL', payload: {open: false}})
        this.props.dispatch({type: 'TOGGLE_ORDER_DETAIL_MODAL', payload: {open: true}})
    }

    closeQueryDialog = () => {
        this.props.dispatch({type: 'TOGGLE_QUERY_MODAL', payload: {open: false}})
    }
    openQueryModal = () => {
        this.props.dispatch({type: 'TOGGLE_QUERY_MODAL', payload: {open: true}})
    }

    manualQuery = (orderNo: string) => {
        this.props.dispatch({
            type: 'GET_ORDERS', payload: {
                type: 'detail', data: {
                    orderNo: orderNo,
                    flag: 1
                }
            }
        })
        // this.setState({
        //     type: 0,
        //     amt: 0,
        //     openOrderNo: orderNo,
        //     manual: true
        // })
        // this.props.dispatch({type: 'TOGGLE_ORDER_DETAIL_MODAL', payload: {open: true}})
    }
    public render() {
        // if (!this.props.latest10List || this.props.latest10List.length === 0) {
        //     return null
        // }

        let gridConfig: { [key: string]: GridSize } = {xs: 12, md: 6, lg: 7, xl: 8},
            itemGridConfig: { [key: string]: GridSize } = {xs: 6, sm: 12, lg: 6, xl: 6}
        if (this.props.superView) {
            gridConfig = {xs: 12, md: 12, lg: 12, xl: 12};
            itemGridConfig = {xs: 6, sm: 6, lg: 4, xl: 3};
        }
        let {intl} = this.props
        return (
            <Grid item xs={gridConfig.xs} md={gridConfig.md} lg={gridConfig.lg} xl={gridConfig.xl}>
                <div className="LatestOrders">
                    <div className="header">
                        <div className="headerLeft">
                            <h2>{intl.formatMessage({id: 'latestOrders'})}</h2>
                            <span className="queryOrder"
                                  onClick={this.openQueryModal}>{intl.formatMessage({id: 'queryOrderManually'})}</span>
                        </div>
                        <a href="/#/app/orders" className="seeMore">{intl.formatMessage({id: 'more'})}</a>
                    </div>
                    <div className="container">
                        {!this.props.latest10List || this.props.latest10List.length === 0 ?
                            <div className="noData">
                                <img src={noDataIcon} alt="no data"/>
                                <p>{intl.formatMessage({id: 'noData'})}</p>
                            </div> : null}
                        <Grid container spacing={2}>
                            {this.props.latest10List.map((item, i) => {
                                return (<Grid item xs={itemGridConfig.xs}
                                              sm={itemGridConfig.sm}
                                              lg={itemGridConfig.lg} xl={itemGridConfig.xl}
                                              key={`${item.orderNo}-${i}`}>
                                    <OrderItem order={item} selectWallet={this.props.selectWallet} onClick={() => this.onOrderClick(item)}/>
                                </Grid>)
                            })}
                        </Grid>
                    </div>
                    <CustomDialog open={this.props.orderDetailModal}
                                  title={intl.formatMessage({id: 'orderDetail'})}
                                  showActions={false}
                                  content={<OrderDetailModal
                                      orderAmt={this.state.amt}
                                      orderType={this.state.type}
                                      openOrderNo={this.state.openOrderNo}
                                      onRefund={this.openRefundDialog}
                                  />}
                                  handleClose={this.closeDialog}/>

                    <CustomDialog open={this.props.refundModal}
                                  title={intl.formatMessage({id: 'refund'})}
                                  showActions={false}
                                  content={<OrderRefundModal origin="dashboard" onClose={this.closeRefundDialog}/>}
                                  handleClose={this.closeRefundDialog}/>


                    <CustomDialog open={this.props.manualQueryModal}
                                  title={intl.formatMessage({id: 'queryOrder'})}
                                  showActions={false}
                                  content={<ManualQueryModal
                                      onQuery={this.manualQuery}
                                      onClose={this.closeQueryDialog}/>}
                                  handleClose={this.closeQueryDialog}/>
                </div>
            </Grid>);
    }
}

export default injectIntl(connect((state: reducerStoreType, props) => {
    return {
        currency: state.app.userInfo ? state.app.userInfo.currency : '',
        latest10List: state.dashboard.indexStat.latest10List,
        refundModal: state.orders.refundModalOpen,
        orderDetailModal: state.orders.orderDetailModalOpen,
        manualQueryModal: state.orders.manualQueryModal
    }
})(LatestOrders))